
<cvt-input
    :value="value"
    type="text"
    label="New Label"
    :clearable="true"
    @input="handleCvtInputChange"
    @keydown="onKeyDown"
/>
